import { type SelectAllEvent } from '../events/types';
import { SELECT_ALL_RANGE_ID, type SelectionState } from '../state/types';
import { isSelectAll } from '../utils/is-select-all';

import { type ReducerResponse } from './types';

const selectAllRange = {
  id: SELECT_ALL_RANGE_ID,
  anchor: { row: { index: 0 }, col: { index: 0 } },
  lead: { row: { index: 0 }, col: { index: 0 } },
} as const;

const newFocus = { row: { index: 0 }, col: { index: 0 } };

export function selectAllReducer(
  state: SelectionState,
  event: SelectAllEvent
): ReducerResponse {
  if (state.selections.length === 1 && isSelectAll(state.selections[0], state.mode)) {
    return {
      delta: {
        kind: 'noop',
      },
      next: state,
    };
  }

  return {
    delta: {
      kind: 'selectionReplaced',
      source: event.source,
      selections: [selectAllRange],
      focusChange: {
        prev: state.focusedCell,
        next: newFocus,
      },
    },
    next: {
      ...state,
      mode: 'row',
      focusedCell: newFocus,
      selections: [selectAllRange],
      lastInteractionSource: event.source,
    },
  };
}
